import loadScript from 'utils/loadScript'

const PADDLE_VENDOR_ID = process.env.PADDLE_VENDOR_ID
const PADDLE_JS_SRC = 'https://cdn.paddle.com/paddle/paddle.js'
const PADDLE_NAME = 'Paddle'

type PaddleClient = {
  Setup: (options: { vendor: number }) => void
}

const loadPaddle = () =>
  loadScript<PaddleClient>(PADDLE_JS_SRC, PADDLE_NAME).then(Paddle => {
    if (!Paddle) return null
    Paddle.Setup({ vendor: parseInt(PADDLE_VENDOR_ID ?? '0', 10) })
    return Paddle
  })

export default loadPaddle
